import React from "react";

//MUI
import styled from "@emotion/styled";
import Dialog from '@mui/material/Dialog';
import Typography from "@mui/material/Typography";

//components
import CustomButton from "../Common/CustomButton";

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  "& .text_info": {
    padding: "1.7rem 0 1rem 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& .del_text_style": {
      fontSize: "15px",
      [theme.breakpoints.down("xl")]: {
        fontSize: "14px",
      },
      [theme.breakpoints.down("lg")]: {
        fontSize: "13px",
      },
    },
  },
  "& .btn_container": {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "0.5rem",
    padding: "0 0.5rem",
    "& .cancel_btn_style": {
      fontSize: "14px",
      [theme.breakpoints.down("xl")]: {
        fontSize: "13px",
      },
      [theme.breakpoints.down("lg")]: {
        fontSize: "12px",
      },
    },
    "& .del_btn_style": {
      fontSize: "14px",
      color: "#FF5252",
      [theme.breakpoints.down("xl")]: {
        fontSize: "13px",
      },
      [theme.breakpoints.down("lg")]: {
        fontSize: "12px",
      },
    }
  }
}));

const ConfirmDelete = (props) => {
  const { onClose, selectedValue, open, onConfirm, fileType } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth={"xs"}
    >
      <Container>
        <div className="text_info">
          <Typography className="del_text_style">Are you sure you want to delete this {fileType}?</Typography>
        </div>
        <div className="btn_container">
          <CustomButton
            onClick={handleClose}
            className="cancel_btn_style"
          >
            Cancel
          </CustomButton>
          <CustomButton
            type="button"
            className="del_btn_style"
            onClick={onConfirm}
          >
            Delete
          </CustomButton>
        </div>
      </Container>
    </Dialog>
  );
};

export default ConfirmDelete;